module.exports = __webpack_public_path__ + "static/media/Admission_Form.2d018199.png";